require("!!/home/jormat/jormat-front/node_modules/script-loader/addScript.js")(require("!!/home/jormat/jormat-front/node_modules/raw-loader/index.js!/home/jormat/jormat-front/bower_components/highcharts/modules/data.js"))


//////////////////
// WEBPACK FOOTER
// ./~/script-loader!./bower_components/highcharts/modules/data.js
// module id = 522
// module chunks = 0